var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00142 7.88771C7.41607 7.88771 7.77057 7.74007 8.0649 7.44479C8.35923 7.14952 8.5064 6.79455 8.5064 6.3799C8.5064 5.96525 8.35876 5.61075 8.06348 5.31642C7.7682 5.02209 7.41324 4.87492 6.99859 4.87492C6.58393 4.87492 6.22944 5.02256 5.93511 5.31784C5.64077 5.61311 5.49361 5.96808 5.49361 6.38273C5.49361 6.79738 5.64125 7.15188 5.93652 7.44621C6.2318 7.74054 6.58677 7.88771 7.00142 7.88771ZM7 15.9245C4.90279 14.1072 3.33015 12.416 2.28207 10.8509C1.234 9.28569 0.709961 7.84872 0.709961 6.53996C0.709961 4.6169 1.33202 3.06002 2.57615 1.86931C3.82026 0.678606 5.29488 0.083252 7 0.083252C8.70513 0.083252 10.1797 0.678606 11.4239 1.86931C12.668 3.06002 13.29 4.6169 13.29 6.53996C13.29 7.84872 12.766 9.28569 11.7179 10.8509C10.6699 12.416 9.09721 14.1072 7 15.9245Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.e025b5310ae77f5ab68bffb9f2394da7.svg";
export { ForwardRef as ReactComponent };